/* Hikari purchase controls: one selected variant and one confirmed cart event. */
(function () {
  'use strict';

  function init() {
    var configElement = document.getElementById('fgh-purchase-config');
    var heroButton = document.getElementById('fgh-atc');
    if (!configElement || !heroButton || configElement.dataset.initialized) return;
    var config;
    try { config = JSON.parse(configElement.textContent); } catch (error) { return; }
    if (!config.variants || !config.variants.length) return;
    configElement.dataset.initialized = 'true';

    var variants = {};
    config.variants.forEach(function (variant) { variants[String(variant.id)] = variant; });
    var swatches = Array.from(document.querySelectorAll('.fgh-swatch, .cta7b-swatch'));
    var buttons = [heroButton, document.getElementById('fgh-sticky-atc'), document.getElementById('cta7b-add')].filter(Boolean);
    var main = document.getElementById('fgh-main');
    var thumbs = document.getElementById('fgh-thumbs');
    var stickyBar = document.getElementById('fgh-sticky');
    var currentVariant;
    var busy = false;
    var errors = {};
    var base = 'https://cdn.shopify.com/s/files/1/0694/3139/4517/files/';
    var images = {
      ivory: ['Ivory-1.jpg?v=1762849415', 'Ivory-2.jpg?v=1763245501', 'Ivory-3.jpg?v=1763245501', 'Ivory-4.jpg?v=1763461175', 'Ivory-5.jpg?v=1763461175'],
      yinyang: ['Black-1.jpg?v=1763461175', 'Black-2.jpg?v=1763461175', 'Black-9.jpg?v=1763461175', 'Black-6.jpg?v=1763461175', 'Black-4.jpg?v=1763461175', 'Black-8.jpg?v=1763461175'],
      black: ['Black.jpg?v=1763461175', 'Black-3.jpg?v=1763461175', 'Black-5.jpg?v=1763461175', 'Black-7.jpg?v=1763461175']
    };

    function route(path) {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      return root.replace(/\/?$/, '/') + path;
    }

    function track(name, extra) {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: 'fgh_' + name, product: 'miyakiwa-hikari-dual-core-2026' }, extra || {}));
      } catch (error) { /* Analytics must not block buying. */ }
    }

    buttons.forEach(function (button) {
      var status = document.createElement('p');
      status.id = button.id + '-error';
      status.hidden = true;
      status.setAttribute('role', 'alert');
      status.setAttribute('tabindex', '-1');
      status.style.cssText = 'margin:8px 0 0;padding:10px 12px;border-radius:6px;background:#fff3f1;color:#8a1919;font:14px/1.5 sans-serif;';
      var target = button.id === 'fgh-sticky-atc' && stickyBar ? stickyBar :
        button.id === 'cta7b-add' ? button.parentNode.parentNode : button.parentNode;
      target.appendChild(status);
      button.setAttribute('aria-describedby', status.id);
      errors[button.id] = status;
      button.addEventListener('click', function () { addToCart(button); });
    });

    function clearErrors() {
      Object.keys(errors).forEach(function (key) { errors[key].hidden = true; errors[key].textContent = ''; });
    }

    function showError(button, message, checkCart) {
      var status = errors[button.id];
      status.textContent = message + ' ';
      if (checkCart) {
        var link = document.createElement('a');
        link.href = route('cart');
        link.textContent = 'Check your cart';
        status.appendChild(link);
      }
      status.hidden = false;
      status.focus({ preventScroll: false });
    }

    function updateButtons() {
      buttons.forEach(function (button) {
        button.disabled = busy || !currentVariant.available;
        button.setAttribute('aria-busy', busy ? 'true' : 'false');
        button.textContent = busy ? 'Adding…' : !currentVariant.available ? 'Sold out' :
          button.id === 'cta7b-add' ? 'Add to Cart' : 'Add to Cart - ' + currentVariant.priceLabel;
      });
      swatches.forEach(function (swatch) { swatch.disabled = busy || !variants[swatch.getAttribute('data-variant')]; });
    }

    function renderGallery(swatch, colour) {
      if (!swatch || !main || !thumbs) return;
      var list = images[swatch.getAttribute('data-key')];
      if (!list) return;
      thumbs.textContent = '';
      list.forEach(function (file, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'fgh-thumb' + (index === 0 ? ' is-active' : '');
        button.setAttribute('role', 'listitem');
        button.setAttribute('aria-label', colour + ' product image ' + (index + 1));
        var image = document.createElement('img');
        image.src = base + file + '&width=160';
        image.alt = colour + ' product image ' + (index + 1);
        image.loading = 'lazy';
        button.appendChild(image);
        button.addEventListener('click', function () {
          main.src = base + file + '&width=1100';
          thumbs.querySelectorAll('.fgh-thumb').forEach(function (thumb) { thumb.classList.remove('is-active'); });
          button.classList.add('is-active');
        });
        thumbs.appendChild(button);
      });
      main.src = base + list[0] + '&width=1100';
      main.alt = 'Miyakiwa Hikari Dual Core 2026 massage chair in ' + colour;
      var stickyImage = document.querySelector('.fgh-sticky__thumb');
      if (stickyImage) { stickyImage.src = base + list[0] + '&width=140'; stickyImage.alt = main.alt; }
    }

    function selectVariant(id, userInitiated) {
      var variant = variants[String(id)];
      if (!variant || busy) return;
      currentVariant = variant;
      clearErrors();
      var selectedSwatches = swatches.filter(function (swatch) { return swatch.getAttribute('data-variant') === String(variant.id); });
      var colour = selectedSwatches.length ? selectedSwatches[0].getAttribute('data-colour') : variant.title;
      swatches.forEach(function (swatch) {
        var selected = swatch.getAttribute('data-variant') === String(variant.id);
        swatch.classList.toggle('is-active', selected);
        swatch.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      ['fgh-colour-name', 'cta7b-colour-name'].forEach(function (id) {
        var label = document.getElementById(id);
        if (label) label.textContent = colour;
      });
      document.querySelectorAll('.fgh-price__now, .cta7b-price, .fgh-sticky__price b').forEach(function (price) { price.textContent = variant.priceLabel; });
      document.querySelectorAll('.fgh-price__was, .cta7b-was, .fgh-sticky__was').forEach(function (price) {
        price.hidden = !(variant.compareAtPrice > variant.price);
        price.textContent = variant.compareAtPriceLabel || '';
      });
      var heroSwatch = selectedSwatches.find(function (swatch) { return swatch.hasAttribute('data-key'); });
      renderGallery(heroSwatch, colour);
      var closerSwatch = selectedSwatches.find(function (swatch) { return swatch.hasAttribute('data-img'); });
      var closerImage = document.getElementById('cta7b-img');
      if (closerImage && closerSwatch) {
        closerImage.src = closerSwatch.getAttribute('data-img');
        closerImage.alt = 'Miyakiwa Hikari massage chair in ' + colour;
      }
      updateButtons();
      if (userInitiated) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState(window.history.state, '', url.href);
        } catch (error) { /* Selection still works if history is unavailable. */ }
        track('colour_select', { colour: colour, variant: String(variant.id) });
      }
    }

    async function addToCart(button) {
      if (busy || !currentVariant || !currentVariant.available) return;
      var requested = currentVariant;
      busy = true;
      clearErrors();
      updateButtons();
      try {
        var response = await fetch(route('cart/add.js'), {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(requested.id), quantity: 1 }] })
        });
        var data;
        try { data = await response.json(); } catch (parseError) { throw new Error('unconfirmed'); }
        if (!response.ok || Number(data && data.status) >= 400 || (data && data.errors)) {
          var rejection = new Error(data && typeof data.description === 'string' ? data.description :
            'This colour could not be added. Please choose another colour or call 1300 804 682.');
          rejection.confirmedRejection = true;
          throw rejection;
        }
        var items = data && Array.isArray(data.items) ? data.items : [data];
        var added = items.find(function (item) {
          return item && String(item.variant_id || item.id) === String(requested.id) && Number(item.quantity) > 0;
        });
        if (!added) throw new Error('unconfirmed');
        var price = Number(added.final_price != null ? added.final_price : added.price != null ? added.price : requested.price) / 100;
        track('add_to_cart', {
          variant: String(requested.id), quantity: 1, value: price, currency: config.currency,
          ecommerce: { currency: config.currency, value: price, items: [{
            item_id: String(config.productId), item_name: config.productTitle,
            item_variant: requested.title, price: price, quantity: 1
          }] }
        });
        window.location.href = route('cart');
      } catch (error) {
        busy = false;
        updateButtons();
        showError(button, error.confirmedRejection ? error.message :
          'We could not confirm the cart update. Please check your cart before trying again, or call 1300 804 682.', !error.confirmedRejection);
      }
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () { selectVariant(swatch.getAttribute('data-variant'), true); });
    });
    document.querySelectorAll('[data-fgh-track]').forEach(function (element) {
      var name = element.getAttribute('data-fgh-track');
      if (name === 'add_to_cart') return; // Confirmed additions are tracked only in addToCart.
      element.addEventListener('click', function () { track(name); });
    });

    var initialId = config.selectedVariantId;
    try {
      var requestedId = new URL(window.location.href).searchParams.get('variant');
      if (variants[requestedId]) initialId = requestedId;
    } catch (error) { /* Use Shopify's selected/first available variant. */ }
    selectVariant(variants[String(initialId)] ? initialId : config.variants[0].id, false);
    window.addEventListener('popstate', function () {
      var id = new URL(window.location.href).searchParams.get('variant');
      selectVariant(variants[id] ? id : config.selectedVariantId, false);
    });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) { busy = false; updateButtons(); }
    });
    if (stickyBar) document.body.appendChild(stickyBar);
    if (stickyBar && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { stickyBar.classList.toggle('is-visible', !entry.isIntersecting); });
      }, { threshold: 0 });
      observer.observe(heroButton);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
